import { Injectable } from '@angular/core';
import { AppSettings } from '@plugin/settings';
import { SideMenu } from './side-menu';

@Injectable({
    providedIn: 'root'
})
export class SideMenuService {
    constructor(private settings: AppSettings) {}

    getMenu() {
        const productVersion = this.settings.get<string>('product-version', 'default');
        return SideMenu.filter(x => x.version === productVersion || x.version === 'default');
    }
}
